<script setup lang="ts">
// GladKey brand wordmark (stroke logo).
// Raster asset lives in /public; size it with a height utility class on the
// element — width follows via the intrinsic ratio. The mark is dark, so on
// dark surfaces (e.g. the footer) add the `invert` utility to render it white.
import logoUrl from '../assets/gladkey-logo.png';
</script>

<template>
  <img :src="logoUrl" alt="GladKey" class="select-none" draggable="false" />
</template>
